<template>
  <Head title="Iniciar sesión" />
  <div class="min-h-screen flex items-center justify-center bg-gray-50 p-4 sm:p-6 lg:p-8">
    <div class="w-full max-w-md">
      <!-- Logo Image -->
      <logo class="block mx-auto w-full max-w-xs fill-white mb-6" height="30" />

      <!-- Form Card -->
      <form class="bg-white rounded-xl shadow-lg overflow-hidden border border-slate-100" @submit.prevent="login">
        <div class="px-6 py-8 sm:px-10 sm:py-10">
          <h1 class="text-2xl font-bold text-gray-900 text-center mb-1">¡Bienvenido!</h1>
          <p class="text-center text-sm text-gray-500 mb-6">Ingresa tus credenciales para acceder a la administración</p>

          <div class="space-y-4">
            <!-- Email Input -->
            <text-input 
              v-model="form.email" 
              :error="form.errors.email" 
              label="Correo Electrónico" 
              type="email" 
              autofocus 
              autocapitalize="off" 
            />
            
            <!-- Password Input -->
            <text-input 
              v-model="form.password" 
              :error="form.errors.password" 
              label="Contraseña" 
              type="password" 
            />

            <!-- Keep Session Active Checkbox -->
            <div class="flex items-center justify-between pt-2">
              <label class="inline-flex items-center select-none cursor-pointer group" for="remember">
                <input 
                  id="remember" 
                  v-model="form.remember" 
                  class="w-4 h-4 text-orange-600 rounded border-gray-300 focus:ring-orange-500 cursor-pointer" 
                  type="checkbox" 
                />
                <span class="ml-2 text-xs text-gray-600 group-hover:text-gray-800 select-none cursor-pointer">
                  Mantener sesión iniciada
                </span>
              </label>
            </div>
          </div>
        </div>

        <!-- Submission Button Wrapper -->
        <div class="px-6 py-4 sm:px-10 bg-slate-50 border-t border-slate-100 flex items-center">
          <loading-button 
            :loading="form.processing" 
            class="w-full bg-orange-600 hover:bg-orange-700 text-white font-bold py-2.5 px-4 rounded-lg shadow hover:shadow-md transition-all duration-200 transform hover:-translate-y-0.5 text-sm uppercase tracking-wide flex justify-center items-center" 
            type="submit"
          >
            Iniciar sesión
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>
